// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn--Hp28j","primaryContactSection":"primaryContactSection--DVwnT"};